
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import usePrevious from "../../../../Shared/components/Previous";
import { useDispatch, useSelector } from "react-redux";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { toast } from 'react-toastify';
import { QuickLinks } from "../../../../Shared/components/BreadCrumbNew/QuickLinks";
import { CustomForm } from './CustomForm';
import customStyles from "../../../../../assets/styles/customStyles";
import qucikLinksActions from "../../../../Dashboard/redux/actions";
import clsx from "clsx";
import crudActions from "../../../../CRUD/redux/actions";
import { useParams } from "react-router-dom";
import { checkCRUDViewPermission } from "../../../../../helpers/utilities";
import { useEventListener } from "../../../../../helpers/useEventListener";
import { AESEncrypt, AESDecrypt } from "../../../../../helpers/Crypto";

const ProductCreate = (props) => {
    const { readDetails, readError } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;
    const classes = customStyles();
    const formRef = useRef('');
    const factBox = [];
    let { productId } = useParams();
    const decryptedId = AESDecrypt(productId);


    const menus = [
        {
            "name": "Batch Number",
            "link": `/product/inventory/batch-numbers/${AESEncrypt(decryptedId)}`,
            'disabled': productId ? false : true
        },
        {
            "name": "Stock On Hand",
            "link": `/product/inventory/stock-on-hand/${AESEncrypt(decryptedId)}`,
            'disabled': productId ? false : true
        },
        {
            "name": "Inventory Transactions",
            "link": `/product/inventory/inventory-transaction/${AESEncrypt(decryptedId)}`,
            'disabled': productId ? false : true
        },
        {
            "name": "Create Supply Bill",
            "link": "",
            'disabled': true
        },
        {
            "name": "Create Supply Quote",
            "link": "",
            'disabled': true
        },
        {
            "name": "Create Purchase Order",
            "link": "",
            'disabled': true
        },
    ];

    const dispatch = useDispatch();

    const { type } = useParams();
    const prevReadDetails = usePrevious(readDetails);
    const prevReadError = usePrevious(readError);
    const [showDetails, setShowDetails] = useState(true);

    useEffect(() => {
        if (productId !== undefined && decryptedId === 0) {
            history.push('/product/product/my-products');
            return true;
        }
        if (roleManagement !== '' && checkCRUDViewPermission('My Products', type, history, 'Product')) {
            loadTask();
        }
    }, [productId, type, roleManagement]);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 83) {
            e.preventDefault();
            if (type !== 'view') {
                formRef?.current?.submitProduct(e);
            }
        } else if (e.altKey && e.keyCode === 69) {
            e.preventDefault();
            if (type === 'view') {
                history.push(`/product/product/my-products/${AESEncrypt(decryptedId)}/edit`);
            }
        }
    };

    useEventListener("keydown", handleKeyDown);

    const loadTask = () => {
        if (productId) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "client-products" });
        }
    }

    useEffect(() => {
        console.log(productId);
        if (!productId) {
            setTimeout(function () {
                dispatch({ type: qucikLinksActions.QUICKLINKS_START, menus: menus, toggle: true, factBox: factBox, component: "My Products" });
            }, 200)
        }
    }, []);

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            formRef.current.onEdit(readDetails);
            setTimeout(function () {
                console.log(readDetails?.facts)
                dispatch({ type: qucikLinksActions.QUICKLINKS_START, menus: menus, toggle: true, factBox: readDetails?.facts, component: "My Products" });
            }, 200)
            setShowDetails(false);
        } else if (prevReadError !== undefined && readError && prevReadError !== readError) {
            if (readError.error.statusCode) {
                toast.error('Product ID is invalid');
                history.push('/product/product/my-products/');
            }
        }
    }, [readDetails, readError]);

    const onParentFunction = () => {
        formRef.current.reSize();
    }

    return (
        <React.Fragment>
            <MainHeader
                {...props}
                img={SettingsImg}
                title={'Product'}
                closeLink={'/product/product/my-products'}
                links={[{ 'label': 'Product', 'link': '/product' }, { 'label': 'My Products', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: type === 'create' ? true : !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer, classes.productForm)}>
                    <CustomForm
                        ref={formRef}
                        showDetails={type === 'create' ? false : showDetails}
                        view={type === 'view' ? true : false}
                        productId={productId === undefined ? productId : decryptedId}
                        type={type}
                        roleManagement={roleManagement}
                        loadTask={() => loadTask()}
                        {...props}
                    />
                </div>
            </div>
            <QuickLinks menus={menus} component={"My Products"} factBox={productId ? readDetails?.facts : {}} onParentFunction={() => onParentFunction()} />
        </React.Fragment>
    )
}
export default ProductCreate